import { render, staticRenderFns } from "./BookingNavigation.vue?vue&type=template&id=160d1689&scoped=true"
import script from "./BookingNavigation.vue?vue&type=script&lang=ts"
export * from "./BookingNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BookingNavigation.vue?vue&type=style&index=0&id=160d1689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160d1689",
  null
  
)

export default component.exports